import React from 'react';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import gfm from 'remark-gfm';

interface HomeHtmlEditorProps {
    element: any
}

const HomeHtmlEditor: React.FC<HomeHtmlEditorProps> = (element) => {


    const handleContent = (content: any) => {
        return <div className='container-fluid  py-5'>
            <ReactMarkdown remarkPlugins={[gfm]} rehypePlugins={[rehypeRaw]}>{content?.Content}</ReactMarkdown>
        </div>;
    }

    return (
      <>
        {element?.element?.ShowIn == 'Both Desktop and Mobile' ? 
        <section className='featured-section tpl-3 fadeInUp position-relative'>
            {handleContent(element?.element)}
        </section>
        : element?.element?.ShowIn == 'Desktop Only' ?
        <section className='featured-section tpl-3 fadeInUp position-relative d-lg-block d-none'>
            {handleContent(element?.element)}
        </section>
        : element?.element?.ShowIn == 'Mobile Only' ?
        <section className='featured-section tpl-3 fadeInUp position-relative d-lg-none d-block'>
            {handleContent(element?.element)}
        </section>
        :<></>}
      </>
    );
};

export default HomeHtmlEditor;